// extracted by mini-css-extract-plugin
module.exports = {"contents":"_2wfhu9MQTig3_fBOxn06YK"};